import * as Cookies from 'js-cookie';
import 'remodal/dist/remodal.css'
import 'remodal/dist/remodal-default-theme.css'
import 'remodal';

$(function(){
  //▼ 歯科医療従事者確認モーダルの表示
  var doctorConfirmModal = $('[data-remodal-id=doctor-confirm]').remodal();
  if (Cookies.get('yes_doctor') !== 'yes') {
    doctorConfirmModal.open();
  }
  $(document).on('confirmation', '[data-remodal-id=doctor-confirm]', function () {
    Cookies.set('yes_doctor', 'yes', { expires: 31 })
  });
  $(document).on('cancellation', '[data-remodal-id=doctor-confirm]', function () {
    window.location.href = 'https://doctorbook.jp/?utm_source=academy&utm_medium=ownedmedia';
  });
  //▼ Facebookログインモーダルの表示
  var facebookLoginModal = $('[data-remodal-id=facebook-login]').remodal();
  $(document).on('click', '#facebook-login', function (e) {
    e.preventDefault();
    facebookLoginModal.open();
  });
  $(document).on('confirmation', '[data-remodal-id=facebook-login]', function () {
    window.location.href = '/auth/facebook';
  });
  $(document).on('cancellation', '[data-remodal-id=facebook-login]', function () {
    facebookLoginModal.close();
  });
  //▼ GMOカード入力モーダルの表示
  var gmoModal = $('[data-remodal-id=gmo-modal]').remodal();
  $(document).on('click', '#gmo_modal_open_btn', function () {
    gmoModal.open();
  });
});
